import { render, staticRenderFns } from "./ForumChatSmallDetails.vue?vue&type=template&id=715a3a30&scoped=true"
import script from "./ForumChatSmallDetails.vue?vue&type=script&lang=js"
export * from "./ForumChatSmallDetails.vue?vue&type=script&lang=js"
import style0 from "./ForumChatSmallDetails.vue?vue&type=style&index=0&id=715a3a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a3a30",
  null
  
)

export default component.exports